import React from "react";
import { useLang } from "@/context/LanguageContext";
import { Heart, Users, Globe2, Mail, Phone, Globe } from "lucide-react";

export default function About() {
  const { t } = useLang();
  const pillarIcons = [Heart, Users, Globe2];
  return (
    <div className="py-14 sm:py-20">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 fade-up">
          <img src="/logo.jpeg" alt="Logo" className="mx-auto w-24 h-24 rounded-2xl object-cover shadow-md ring-4 ring-[#F97316]/20" />
          <span className="mt-4 inline-block text-xs font-bold uppercase tracking-widest text-[#F97316]">{t.about.title}</span>
          <h1 className="mt-2 font-display font-extrabold text-3xl sm:text-4xl text-[#0B3D91]" data-testid="about-title">
            {t.tagline}
          </h1>
        </div>
        <div className="card-elevated p-8 sm:p-10 fade-up">
          <p className="text-base sm:text-lg text-[#3D4A6E] leading-relaxed" data-testid="about-body-page">
            {t.about.body}
          </p>
        </div>
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
          {t.about.pillars.map((p, i) => {
            const Icon = pillarIcons[i];
            return (
              <div key={p.t} className="card-elevated p-6" data-testid={`about-pillar-${i}`}>
                <div className={`w-11 h-11 rounded-xl ${i === 1 ? "brand-orange-bg" : "brand-blue-bg"} text-white flex items-center justify-center mb-3`}>
                  <Icon size={20} />
                </div>
                <h3 className="font-display font-bold text-lg text-[#0B3D91]">{p.t}</h3>
                <p className="mt-1.5 text-sm text-[#5A6A94] leading-relaxed">{p.d}</p>
              </div>
            );
          })}
        </div>
        <div className="mt-10 card-elevated p-6 flex flex-col sm:flex-row items-center gap-6 justify-around">
          <a href="mailto:info@sseuropa.com" className="flex items-center gap-2 text-[#0B3D91] hover:text-[#F97316]"><Mail size={18} /> info@sseuropa.com</a>
          <a href="tel:+393520716656" className="flex items-center gap-2 text-[#0B3D91] hover:text-[#F97316]"><Phone size={18} /> +39 352 0716656</a>
          <a href="https://www.sseuropa.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-[#0B3D91] hover:text-[#F97316]"><Globe size={18} /> www.sseuropa.com</a>
        </div>
      </div>
    </div>
  );
}
